import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { select, Store } from '@ngrx/store';
import { actionCountriesListGet, countriesList } from 'src/app/core';
import { notIncludedIn } from 'src/app/core/form-validators/not-included-in.validator';

@UntilDestroy()
@Component({
  selector: 'app-countries-list-input',
  templateUrl: './countries-list-input.component.html',
  styleUrls: ['./countries-list-input.component.less'],
})
export class CountriesListInputComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() availableCountryCodes: string[];

  @Output() onSelect: EventEmitter<string | boolean> = new EventEmitter<
    string | boolean
  >();

  countriesList = [];
  filteredOptions = [];
  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(actionCountriesListGet());
    this.getCountriesList();
  }

  private getCountriesList(): void {
    this.store
      .pipe(select(countriesList), untilDestroyed(this))
      .subscribe((countriesList) => {
        if (countriesList) {
          let countryList = [];
          Object.entries(countriesList).map((entry) => {
            let key = entry[0];
            let value = entry[1];
            countryList.push({ text: value, value: key });
          });
          this.countriesList = countryList.filter((item) =>
            this.availableCountryCodes.includes(item.value)
          );
          this.filteredOptions = this.countriesList;

          let countriesListValues = this.countriesList.map(
            (item) => item.value
          );
          this.formGroup
            .get(this.controlName)
            .setValidators([notIncludedIn(countriesListValues)]);
        }
      });
  }

  onChange(value): void {
    let filteredOptions = this.countriesList.filter(
      (option) =>
        option?.text.toLowerCase().indexOf(value?.toLowerCase()) !== -1
    );

    this.filteredOptions = filteredOptions.length
      ? filteredOptions
      : this.countriesList;

    if (!this.formGroup.get(this.controlName).errors) {
      this.onSelect.emit(true);
    } else {
      this.onSelect.emit(false);
    }
  }
}
